import { combineReducers } from "redux";
import authReducer from "./authReducer";
// reducer created automatically by react form library
//import { reducer } from 'redux-form'; // refactor this so we know what is this reducer
import { reducer as reduxForm } from 'redux-form';

// surveys add reducer
import surveysReducer from "./surveysReducer";

export default combineReducers({
    auth: authReducer,
    form: reduxForm,
    surveys: surveysReducer
});